// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/artifacts/v1/cdc.proto (package chalk.artifacts.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/artifacts/v1/cdc.proto.
 */
export const file_chalk_artifacts_v1_cdc: GenFile = /*@__PURE__*/
  fileDesc("ChxjaGFsay9hcnRpZmFjdHMvdjEvY2RjLnByb3RvEhJjaGFsay5hcnRpZmFjdHMudjEiMQoRQ0RDVGFibGVSZWZlcmVuY2USDAoEbmFtZRgBIAEoCRIOCgZzY2hlbWEYAiABKAkiXAoJQ0RDU291cmNlEhgKEGludGVncmF0aW9uX25hbWUYASABKAkSNQoGdGFibGVzGAIgAygLMiUuY2hhbGsuYXJ0aWZhY3RzLnYxLkNEQ1RhYmxlUmVmZXJlbmNlYgZwcm90bzM");

/**
 * @generated from message chalk.artifacts.v1.CDCTableReference
 */
export type CDCTableReference = Message<"chalk.artifacts.v1.CDCTableReference"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string schema = 2;
   */
  schema: string;
};

/**
 * Describes the message chalk.artifacts.v1.CDCTableReference.
 * Use `create(CDCTableReferenceSchema)` to create a new message.
 */
export const CDCTableReferenceSchema: GenMessage<CDCTableReference> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_cdc, 0);

/**
 * @generated from message chalk.artifacts.v1.CDCSource
 */
export type CDCSource = Message<"chalk.artifacts.v1.CDCSource"> & {
  /**
   * @generated from field: string integration_name = 1;
   */
  integrationName: string;

  /**
   * @generated from field: repeated chalk.artifacts.v1.CDCTableReference tables = 2;
   */
  tables: CDCTableReference[];
};

/**
 * Describes the message chalk.artifacts.v1.CDCSource.
 * Use `create(CDCSourceSchema)` to create a new message.
 */
export const CDCSourceSchema: GenMessage<CDCSource> = /*@__PURE__*/
  messageDesc(file_chalk_artifacts_v1_cdc, 1);

